import { render, staticRenderFns } from "./UserLogin.vue?vue&type=template&id=c19c4f70&"
import script from "./UserLogin.vue?vue&type=script&lang=ts&"
export * from "./UserLogin.vue?vue&type=script&lang=ts&"
import style0 from "./UserLogin.vue?vue&type=style&index=0&lang=less&"
import style1 from "./UserLogin.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports